export const OAUTH_RESPONSE_TYPE: string = 'code'
export const OAUTH_WINDOW_SIZING: string = 'width=700,height=800'

export const INTERVAL_PERIOD: number = 750
